import { gql, useQuery } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { OutcomeStatus } from '@/lib/apollo/model/outcome'
import type { WrappedUseQuery } from '@/lib/apollo/types'

const getUnableToVerifyIncomeResultQuery = gql`
  query (
    $customerId: String!
    $applicationId: String!
    $subjectId: String!
    $incomeId: String!
    $userId: String!
    $reason: String
  ) {
    getUnableToVerifyIncomeResult(
      customerId: $customerId
      applicationId: $applicationId
      subjectId: $subjectId
      incomeId: $incomeId
      userId: $userId
      reason: $reason
    ) {
      totalAmountVerified
      outcomeStatus
      decisionComments
    }
  }
`

type GetUnableToVerifyIncomeResult = {
  outcomeStatus: OutcomeStatus
  totalAmountVerified: number
  decisionComments: string[]
}

export type GetUnableToVerifyIncomeResultData = {
  getUnableToVerifyIncomeResult: GetUnableToVerifyIncomeResult | null
}

export type QueryVars = {
  customerId: string
  applicationId: string
  subjectId: string
  incomeId: string
  userId: string
  reason?: string
}

export const useGetUnableToVerifyIncomeResultQuery: WrappedUseQuery<
  GetUnableToVerifyIncomeResultData,
  QueryVars
> = options =>
  useQuery<GetUnableToVerifyIncomeResultData, QueryVars>(
    getUnableToVerifyIncomeResultQuery,
    {
      ...options,
      client: agentClient,
    },
  )
